import type { AssignedState } from "../../../components/AssignedStateToggle";

export type ImportView = "active" | "deleted";

export type Filters = {
  view: ImportView;
  warnings: AssignedState;
  importers: string[];
  namePattern: string;
  from: string | null;
  to: string | null;
};

export const defaultFilters: Filters = {
  view: "active",
  warnings: "any",
  importers: [],
  namePattern: "",
  from: null,
  to: null,
};

export const isDefaultFilters = (f: Filters): boolean =>
  f.warnings === "any" &&
  f.importers.length === 0 &&
  f.namePattern === "" &&
  f.from === null &&
  f.to === null;
